"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const examples_1 = require("./examples");
exports.App = () => (React.createElement(examples_1.FormExample, null));
exports.App.displayName = 'App';



//////////////////
// WEBPACK FOOTER
// ./src/demo/App.tsx
// module id = 233
// module chunks = 0